import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isNew: true,
  isDataChanged: false,
  reloadPage: false,
  data: {},
};

export const DocumentsInformationSlice = createSlice({
  name: "documentInformation",
  initialState,
  reducers: {
    updateDocumentInformationData: (state, { payload: { key, value, required } }) => {
      state.isDataChanged = true;
      state.data[key] = value;
      if (value !== undefined) {
        if (value.length === 0) {
          if (required) {
            state.data[key] = value;
          } else {
            delete state.data[key];
          }
        } else {
          state.data[key] = value;
        }
      }
    },
    setIsDataChangedForDocuments: (state, { payload }) => {
      state.isDataChanged = payload;
    },
    setIsNewForDocumentInformation: (state, { payload }) => {
      state.isNew = payload;
    },
    setDocumentInformationData: (state, { payload }) => {
      state.isNew = false;
      state.data = payload;
    },
    clearDocumentsInformationData: () => initialState,
    setReloadDocumentsInformationData: (state, { payload }) => {
      state.reloadPage = payload;
    },
  },
});
export const {
  updateDocumentInformationData,
  setIsDataChangedForDocuments,
  setIsNewForDocumentInformation,
  setDocumentInformationData,
  clearDocumentsInformationData,
  setReloadDocumentsInformationData,
} = DocumentsInformationSlice.actions;
export const DocumentsInformationReducer = DocumentsInformationSlice.reducer;
